import React from "react";
import YouTube from "react-youtube";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/**
 * Video Player Modal
 * Modernized with shadcn Dialog component
 */
function VideoModal({ hideModal, videoId, videoName }) {
    const onReady = (event) => {
        const player = event.target;
        player.playVideo();
    };

    const opts = {
        playerVars: {
            autoplay: 1,
        },
        width: '100%',
        height: '400px',
    };

    return (
        <Dialog open={true} onOpenChange={hideModal}>
            <DialogContent className="sm:max-w-[560px]">
                <DialogHeader>
                    {videoName && (
                        <DialogTitle className="text-primary">{videoName}</DialogTitle>
                    )}
                </DialogHeader>
                <div className="py-4">
                    <div className="aspect-video w-full rounded-lg overflow-hidden bg-black">
                        <YouTube 
                            videoId={videoId} 
                            opts={opts} 
                            onReady={onReady}
                            className="w-full h-full"
                        />
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default VideoModal;
